<template>
  <b-card>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.date"
            type="date"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>
    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickView(data.item.id)"
            v-if="data.item.statusid === 5"
            >{{ data.value.id }}VIEW</b-button
          >
          <b-button
            variant="primary"
            size="sm"
            @click="onClickChange(data.item.id)"
            v-else
            >{{ data.value.id }}EDIT</b-button
          >
        </span>
      </template>
      <template v-slot:cell(date)="data">
        {{ moment(data.value).format("DD/MM/YYYY") }}
      </template>
    </b-table>
    <b-pagination
      v-if="!isLoading"
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>
  </b-card>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      moment: moment,
      items: [],
      filter2: null,
      select: {
        pro_cat: [
          { text: "UHT", value: "1" },
          { text: "Pasteurized", value: "2" }
        ],
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Date", value: "1" }
        ]
      },
      form: {
        date: null
      },
      indexsearch: 1,
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      },

      // Loader
      isLoading: false
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.date = this.date !== "null" ? this.date : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        this.getDO();
      }
    } else {
      this.getDO();
    }
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    filter: {
      type: String,
      default: null
    },
    page: {
      type: String
    },
    date: {
      type: String
    }
  },
  methods: {
    onClickView(id) {
      this.$router.push({
        path: `viewDOUser?id=${id}&cat=4&page=${this.pagination.current}&filter=${this.filter2}&date=${this.form.date}`
      });
    },
    onClickChange(id) {
      this.$router.push({
        path: `createdo?id=${id}&cat=4&type=update`
      });
    },
    resetFilter() {
      this.form.date = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.date = null;
      this.pagination.current = 1;
      this.getDO();
    },
    onClickSearch() {
      this.isLoading = true;
      this.form.page = this.indexsearch;
      if (this.filter2 === null) {
        this.getDO();
      } else {
        this.$store.dispatch("searchDO", this.form).then(res => {
          this.isLoading = false;
          this.items = [];
          res.data.data.data.forEach(element => {
            this.items.push({
              date: element.date,
              type: element.type,
              status: element.status_details.desc,
              statusid: element.status,
              id: element.delivery_id,
              purchase_id: element.purchase_id
            });
          });
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },
    getDO() {
      this.isLoading = true;
      this.$store.dispatch("getDOList", this.pagination.current).then(res => {
        this.isLoading = false;
        this.items = [];
        res.data.data.data.forEach(element => {
          this.items.push({
            date: element.date,
            type: element.type,
            status: element.status_details.desc,
            statusid: element.status,
            id: element.delivery_id,
            purchase_id: element.purchase_id
          });
        });
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
      });
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getDO();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    },
    resetIndex() {
      this.indexsearch = 1;
    }
  }
};
</script>
<style lang="css" scoped></style>
